import { isEmpty } from '@sgme/fp';
import { Box, HStack, VStack } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useState } from 'react';

import { InputGroup1 } from '@/App/tiles/TargetAccumulator/InputGroup1';
import { InputGroup2 } from '@/App/tiles/TargetAccumulator/InputGroup2';
import { InputGroup3 } from '@/App/tiles/TargetAccumulator/InputGroup3';
import { InputGroup4 } from '@/App/tiles/TargetAccumulator/InputGroup4';
import RightColumnHeader from '@/App/tiles/TargetAccumulator/RightColumnHeader.tsx';
import { NoSchedule } from '@/App/tiles/TargetAccumulator/Schedule/NoSchedule';
import ScheduleHeader from '@/App/tiles/TargetAccumulator/Schedule/ScheduleHeader';
import SchedulerTable from '@/App/tiles/TargetAccumulator/Schedule/SchedulerTable';
import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';

const UnzoomedTileSchedulerView = () => {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const hasSchedule = useTargetAccumulatorSelector(
    (targetAccumulator) => !isEmpty(targetAccumulator.properties.scheduleIds),
  );

  const [parametersAreVisible, setParametersAreVisible] = useState(true);

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <VStack flex="expand" verticalAlignment="start">
        <Box flex="min" className="mx-3 my-1 border">
          <HStack
            onClick={() => {
              sgwtWebAnalytics?.trackEvent(
                'Target Accumulator',
                parametersAreVisible ? 'Parameters hidden' : 'Parameters shown',
              );

              setParametersAreVisible(!parametersAreVisible);
            }}
            className="cursor-pointer p-2"
          >
            <span className="active ms-16px mb-8px fw-semibold">Schedule parameters</span>
            <button type="button" className="btn btn-sm btn-link btn-icon-text pe-0">
              <i className="icon icon-sm line-height-1 btn-group text-xxlarge ms-auto">
                {parametersAreVisible ? 'unfold_less' : 'unfold_more'}
              </i>
            </button>
          </HStack>
          {parametersAreVisible && (
            <HStack verticalAlignment="start" gap="4px" className="px-2 pb-2">
              <VStack className="px-1 w-50">
                <div>
                  <InputGroup1 />
                </div>
                <div className="mt-2">
                  <InputGroup2 />
                </div>
              </VStack>
              <VStack verticalAlignment="start" className="px-1 w-50">
                <div>
                  <InputGroup3 useShortLabels />
                </div>
                <div className="mt-2">
                  <InputGroup4 />
                </div>
              </VStack>
            </HStack>
          )}
        </Box>
        {hasSchedule ? (
          <Box flex="expand" className="border m-3 mt-1">
            <ScheduleHeader
              parametersAreVisible={parametersAreVisible}
              setParametersAreVisible={setParametersAreVisible}
            />
            <SchedulerTable keepSmall={parametersAreVisible} />
          </Box>
        ) : (
          <Box flex="expand" className="m-3 mt-1 p-2 border">
            <NoSchedule />
          </Box>
        )}
      </VStack>
    </VStack>
  );
};

export default UnzoomedTileSchedulerView;
